import React, { useState } from "react";

const ProjectForm = ({ initialData = {}, onSubmit }) => {
  const [form, setForm] = useState({
    name: initialData.name || "",
    client: initialData.client || "",
    status: initialData.status || "active",
  });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit?.(form);
  };

  return (
    <form id="modal-form" onSubmit={handleSubmit} className="space-y-4">
      <input
        name="name"
        placeholder="Project Name"
        value={form.name}
        onChange={handleChange}
        className="w-full border p-2 rounded"
      />
      <input
        name="client"
        placeholder="Client"
        value={form.client}
        onChange={handleChange}
        className="w-full border p-2 rounded"
      />
      <select
        name="status"
        value={form.status}
        onChange={handleChange}
        className="w-full border p-2 rounded"
      >
        <option value="active">Active</option>
        <option value="on_hold">On Hold</option>
        <option value="completed">Completed</option>
      </select>
    </form>
  );
};

export default ProjectForm;
